<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">添加机构费用</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">

                <el-form :model="addForm" :rules="rules" ref="addForm">
                    <div>
                        <el-row>
                            <el-col :span="12" class="item">
                                <el-form-item label="选择机构"  required prop="institutionCode">
                                    <el-select v-model="addForm.institutionCode" filterable  placeholder="请选择"  style="width:100%;">
                                        <el-option
                                            v-for="item in institutionValue"
                                            :key="item.institutionCode"
                                            :label="item.name"
                                            :value="item.institutionCode">
                                            </el-option>
                                        </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="设置入住自动收费规则"  required prop="chargeTime">
                                    <el-select v-model="addForm.chargeTime" placeholder="请选择"  style="width:100%;">
                                        <el-option
                                            v-for="item in chargeTimeValue"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value"
                                            >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="设置入住是否自动扣费"  required prop="autoCharge">
                                    <el-select v-model="addForm.autoCharge" placeholder="请选择"  style="width:100%;">
                                        <el-option
                                            v-for="item in autoChargeValue"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                </el-form>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";


    export default {
        name: 'Add',
        data() {
            return {
                loading: false,
                institutionValue:null,
                chargeTimeValue:[{
                    value: 'day',
                    label: '天',
                    }, {
                    value: 'month',
                    label: '月'
                }],
                autoChargeValue:[{
                    value: '0',
                    label: '不自动扣费'
                    }, {
                    value: '1',
                    label: '自动扣费'
                }],
                addForm:{
                    timeStr:timeStr,
                    sign:'',
                    institutionCode:'',
                    chargeTime:'',
                    fixedFee:0,
                    autoCharge:''
                },
                rules:{
                    institutionCode:[
                        { required: true, message: '请选择机构', trigger: 'blur' },
                    ],
                    chargeTime:[
                        { required: true, message: '请选择收费规则', trigger: 'blur' },
                    ],
                    autoCharge:[
                        { required: true, message: '请设置是否自动扣费', trigger: 'blur' },
                    ],
                }
            }
        },

        methods: {
            init(){
                this.getInstitutionList();
            },
            getInstitutionList(){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Institution/List",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then( (response)=> {
                    if(response.data.error == 0){
                        console.log(response.data.data.listInstitution);
                        this.institutionValue = response.data.data.listInstitution;
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            closeSelf() {
                this.$emit("closeAdd");
            },
            confirm(addForm){
                this.$refs[addForm].validate((valid) => {
                    if(valid){
                        this.addSubmit(addForm);
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })

            },

            addSubmit(addForm){
                this.loading = true;
                
                this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"InstitutionArg/ArgSet",
                    data: this.addForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$refs[addForm].resetFields();
                            this.$emit("closeAdd");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },


        }
    }


</script>





<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:   0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 1200px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                height: 100%;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
